import _symbolConstructorDetection from "../internals/symbol-constructor-detection";
var exports = {};
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = _symbolConstructorDetection;
exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
export default exports;